<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" unlink-panels :picker-options="pickerOptions" 
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
					<form-query-button  @select-type="getDataList" >  </form-query-button>
				</el-form-item>
			</el-form>
		</el-col>
        
        <vxe-toolbar :span="24" class="toolbar" style="padding-bottom: 0px;width: 100%;">
           	<template v-slot:buttons>
                <vxe-button icon="fa fa-trash" @click="$refs.xTable.removeCheckboxRow()">删除选中</vxe-button>
                <vxe-button icon="fa fa-save" @click="saveEvent">提交审核</vxe-button>
                <vxe-button icon="fa fa-mail-reply"  @click="revertEvent">界面数据还原</vxe-button>
                <vxe-button icon="fa fa-plus" @click="showAdd()">录入数据</vxe-button>
            </template>
		</vxe-toolbar>

		<vxe-table :data="dataList" border   show-overflow keep-source ref="xTable" :loading="listLoading" :height="formHeight"  style="width: 100%;" :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"   >
            <vxe-table-column    type="checkbox"   width="55">   </vxe-table-column >
			<vxe-table-column  field="time" title="监测时间" fixed sortable min-width="160"></vxe-table-column >
			<vxe-table-column 
				v-for="item in facList" :field="item.keyWord" :title="item.title" :key="item.keyWord"  :edit-render="{name: '$input', props: {type: 'number'}}"  min-width="150">
				<template slot-scope="scope">
					<span >{{scope.row[item.keyWord]}}</span>
				</template>
			</vxe-table-column >
		</vxe-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[ 10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

        <el-dialog title="数据录入" :visible.sync="addFormVisible" :close-on-click-modal="false" :append-to-body="true"  width="80%"  >
            <vxe-button icon="fa fa-plus" @click="insertEvent()">新增</vxe-button>
            <vxe-button icon="fa fa-save" @click="addHandView()">提交</vxe-button>
            <vxe-button icon="fa fa-upload" @click="showUpload()">识别导入</vxe-button>
            <vxe-button icon="fa fa-download" @click="exportData()">模板下载</vxe-button>
            <vxe-table :data="dataAddList" border   show-overflow keep-source ref="addTable"  style="width: 100%;margin-top:10px" :edit-config="{trigger: 'click', mode: 'cell'}"   >
                <vxe-table-column  type="checkbox"   width="55">   </vxe-table-column >
                <vxe-table-column  field="time" title="监测时间"  :edit-render="{name: '$input', props: {type: 'datetime', placeholder: '请选择时间'}}"  min-width="160"></vxe-table-column >
                <vxe-table-column  v-for="item in facList" :field="item.keyWord" :title="item.title" :key="item.keyWord"  :edit-render="{name: '$input', props: {type: 'number'}}"  min-width="150">
                    <template slot-scope="scope">
                        <span >{{scope.row[item.keyWord]}}</span>
                    </template>
                </vxe-table-column >
            </vxe-table>
		</el-dialog>

        <el-dialog title="识别导入" :visible.sync="uploadVisible" :close-on-click-modal="false" :append-to-body="true"  width="80%"  >
           	<el-upload class="upload-demo" action="#" ref="upload" name="file" :on-change="change" 
			    :before-upload="progressing"  v-loading="upoloadLoading"  element-loading-text="文件上传中" element-loading-spinner="el-icon-loading"
			    accept=".xls, .xlsx"  :multiple='false' :file-list="fileList"  :auto-upload="false"  drag>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">提示：仅允许导入“xls”或“xlsx”格式文件！</div>
				<div class="el-upload__tip" slot="tip">提示：请先下载模板再上传，格式不允许修改！</div>
            </el-upload>
            <div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSet">取消</el-button>
				<el-button type="primary" @click.native="uploadHandView">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import { getProjects,getDevicesByProjectId,selectHandView,deleteAndUpdataHandView,addHandView,uploadHandView,getFactorsByMn} from '../../api/api';
	import {formatDate,in_array,factorExcept,hourFactorExcept} from '../../../static/fun.js';

	import FormQueryButton from '../../components/myButton/FormQueryButton.vue'

	export default {
	components: { FormQueryButton },
		data() {
			return {
				pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				filters: {
					projectId:"",
					mn:"",
					time:[]
				},
				total: 0,
				page:1,
				pageSize:10,
				listLoading: false,
				dataList:[],
				firstFlag:true,
				devices:[],
				facList:[],
				facKeyWordList:[],
				projects:[],
				formHeight:0,

                type:sessionStorage.getItem("type"),
                sels:[],
                dataMn:'',

                addFormVisible:false,
                dataAddList:[],

                uploadVisible:false,
                fileList:[],
				length:0,
				upoloadLoading:false
			}
			
		},
		methods: {
            exportData(){
                require.ensure([], () => {
                    const { export_json_to_excel } = require('vendor/Export2Excel');
                    const tHeader =  [ '监测时间' ];
                    const filterVal = ['time' ];  
                    for(var i=0;i<this.facList.length;i++){
                        var element=this.facList[i];
                        tHeader.push(element.name);
                        filterVal.push(element.keyWord);
                    }
                    var data=[];
                    var sheetName=[];
                    data.push(this.formatJson(filterVal, this.dataAddList));
                    sheetName.push('Sheet1');

                    export_json_to_excel(tHeader, data, '数据录入模板',sheetName);
                }) 
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            }, 
            selsChange: function (sels) {
				this.sels = sels;
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getDataList();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getDataList();
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					//如果当前已选的设备不属于选中的项目，把设备置空
					var flag=false;
					if(this.filters.deviceId!=""){
						this.devices.forEach(item => {
							if(item.mnCode==this.filters.mn){
								flag=true;
							}
						});		
					}
					if(!flag&&this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
					}
					if(this.firstFlag){
						this.firstFlag=false;
						this.getDataList();
					}
				});
            },
			//获取历史数据信息
			getDataList(){
				var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
                }
				let para = {
					page: this.page,
					pageSize:this.pageSize,
                    mn: this.filters.mn,
					startDate: starttime,
                    endDate: endtime
				};
				this.listLoading = true;
				selectHandView(para).then((res) => {
					this.listLoading = false;
					this.noiseDevice=false;
					if(res.data.result=="false"){
                        this.$message({
                            message: "查询失败，请重试",
                            type: 'error'
                        })
						return;
                    }
					this.total = res.data.total;
					this.dataList = res.data.data;
                    this.dataMn=this.filters.mn;
					if(this.dataList.length>0){
						this.facList=[];
						this.facKeyWordList=[];
						var arr=factorExcept();
						for (var element in this.dataList[0]) {
							if(in_array(element,arr)){
								continue
							}
							if(in_array(element,hourFactorExcept())){
								continue
							}
							var obj=JSON.parse(sessionStorage.getItem(element));
							if(element=="aqi"){
								obj.title=obj.name;
							}else if(element=="wuranwu"){
								obj=JSON.parse(sessionStorage.getItem("primarypollutant"));
								obj.keyWord="wuranwu";
								obj.title=obj.name;
							}else if(obj.unit.trim()!=""){
								obj.title=obj.name+'('+obj.unit+')';
							}else{
								obj.title=obj.name;
							}
							this.facList.push(obj);
							this.facKeyWordList.push(obj.keyWord);
						}
						
					}else{
						this.getFactorsByMn();
					}
				});
			},
			//获取选中设备可监测的因子
			getFactorsByMn(){
                let para = {
                    mn: this.filters.mn,
                    dataType:"hour"
                };
				getFactorsByMn(para).then((res) => {
					var factors = res.data.data;
					if(factors.length>0){
						this.facKeyWordList=[];
						this.facList=[];
						for (var i=0;i<factors.length;i++) {
							var obj=factors[i];
							var fac=obj.keyword;
							if(fac=="id"||fac=="time"||fac=="mn"||fac=="isValid"||fac.indexOf("_aqi")!=-1||fac=="primarypollutant"||fac=="content"||fac=="autoFlag"){
								continue;
							}
							if(fac=="aqi"){
								obj.title=obj.name;
							}else if(fac=="wuranwu"){
								obj=JSON.parse(sessionStorage.getItem("primarypollutant"));
								obj.keyword="wuranwu";
								obj.title=obj.name;
							}else if(obj.unit.trim()!=""){
								obj.title=obj.name+'('+obj.unit+')';
							}else{
								obj.title=obj.name;
							}
							obj.keyWord=obj.keyword;
							obj.name=obj.name;

							this.facList.push(obj);
							this.facKeyWordList.push(fac);
                        };
                    }
				});
            },
            async insertEvent (row) {
              let record = { }
              let { row: newRow } = await this.$refs.addTable.insertAt(record, row)
            },
            revertEvent () {
                this.$confirm('您确定要还原数据吗?', '提示', {
					type: 'warning'
				}).then(() => {
                  this.$refs.xTable.revertData()
                }).catch(() => {

				});
			},
			saveEvent () {
              const {  removeRecords, updateRecords } = this.$refs.xTable.getRecordset();
              var str="确定删除"+removeRecords.length+"条，更新"+updateRecords.length+"条记录吗？"
              this.$confirm(str, '提示', {
					type: 'warning'
				}).then(() => {
					let formData = new FormData();
					formData.append("removeRecords",JSON.stringify(removeRecords));
					formData.append("updateRecords",JSON.stringify(updateRecords));
					formData.append("mn",this.dataMn);
					formData.append("facList",JSON.stringify(this.facKeyWordList));

					deleteAndUpdataHandView(formData).then((res) => {
						let resData = res.data;
						if (resData.result != true) {
							this.$message({
							message: "提交失败",
							type: 'error'
						})}else{
							this.$message({
								message: '提交成功',
								type: 'success'
							});
                            this.getDataList();
						}
					});
				}).catch(() => {

				});
            },
            addHandView () {
              const {  insertRecords } = this.$refs.addTable.getRecordset();
              var str="确定新增"+insertRecords.length+"条记录吗？"
              this.$confirm(str, '提示', {
					type: 'warning'
				}).then(() => {
					let formData = new FormData();
					formData.append("insertRecords",JSON.stringify(insertRecords));
					formData.append("mn",this.dataMn);
					formData.append("facList",JSON.stringify(this.facKeyWordList));

					// let para={
					// 	insertRecords:insertRecords,
					// 	mn:this.dataMn,
					// 	facList:this.facList
					// }
					addHandView(formData).then((res) => {
						let resData = res.data;
						if (resData.result != true) {
							this.$message({
							message: "提交失败",
							type: 'error'
						})}else{
							this.$message({
								message: '提交成功',
								type: 'success'
							});
                            this.addFormVisible=false;
							this.dataAddList=[];
                            this.getDataList();
						}
					});
				}).catch(() => {

				});
            },
            showUpload(){
                const {  insertRecords } = this.$refs.addTable.getRecordset();
                if(insertRecords.length>0){
                    var str="确定放弃表格中已新增数据，进行识别导入吗"
                    this.$confirm(str, '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.uploadVisible=true;
                    }).catch(() => {

                    });
                }else{
                    this.uploadVisible=true;
                }
            
            },
            uploadHandView(){
                var str="确定导入数据记录吗？"
                this.$confirm(str, '提示', {
					type: 'warning'
				}).then(() => {
					let formData = new FormData();
                    if(this.fileList.length>0){
                        formData.append("excle", this.fileList[0]);
                    } else{
                        this.$message({
                            message: '暂无文件上传，请先上传文件再提交',
                            type: 'success'
                        });
                        return;
                    }
					formData.append("facList", JSON.stringify(this.facList));
                    formData.append("mn",this.dataMn);
                    //	走接口
                    uploadHandView(formData).then(res => {
                        this.fileList=[];
                        if (res.data.result==true) {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            this.addFormVisible=false;
                            this.uploadVisible=false;
                            this.getDataList();
                        }else{
                            this.$message({
                                message: "提交出错，请重试",
                                type: 'error'
                            })
                        }
                    })
				}).catch(() => {
				});
            },
            showAdd(){
                this.addFormVisible=true;
            },
            cancleSet(){
                this.uploadVisible=false;
            },
            change:function(file, fileList){
				this.upoloadLoading=false;
				//判断上传文件数量
				this.length=document.querySelector("input[type=file]").files.length;
				if(this.length>0){
                    this.fileList=[];
					Array.from(document.querySelector("input[type=file]").files).forEach(file=>{
						if(this.fileList.indexOf(file) == -1){
							this.fileList.push(file);
						}
					})
				}
				return false;
			},
			progressing(){
				console.log("progress")
				this.upoloadLoading=true;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-250;
			},
			setTime(){
				var end = new Date();
				var start = new Date();
				//设置不同的时间区间
                start.setTime(start.setDate(start.getDate()-1));
				this.filters.time= [formatDate(start), formatDate(end)];
				this.getProjects();
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			
			this.setTime();
		},
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }
    .vxe-modal--wrapper{
		z-index: 3000!important;
	}
	.type--datetime{
		z-index: 3000!important;
	}


// WEBPACK FOOTER //
// DataManagement.vue?be263976